<template>
  <div>
    <LastPhoto :items="items" v-if="canSee"/>
  </div>
</template>
<script>
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import LastPhoto from "@/components/molecules/LastPhoto";

export default {
  name: "RightSideBarGroup",
  props:["canSee"],
  mixins: [GroupHelperVue],
  components: {
    LastPhoto
  },
  computed: {
    items() {
      const currentItems = this.getCurrentGroupItems || [];
      return currentItems.slice().reverse()
    }
  }
};
</script>
